import cn from 'classnames';
import { Localization } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import style from '../style';

const { Translate } = Localization;

const Styled = styled.div`
  ${style}
`;
const MaterialInfo = ({ data }) => {
  let mix = '';
  if (data?.lineItems && data?.lineItems.length > 0) {
    data?.lineItems.forEach((lineItem, key) => {
      if (lineItem.isPrimary) {
        mix = lineItem.item.id + ' / ' + lineItem.item.description;
      }
    });
  }

  const unsure = '??';

  return (
    <Styled className={cn('test-form')}>
      <div className="body">
        <Translate stringId="material" data-testid="materialLabel" /> : <span data-testid="material"> {mix} </span>
      </div>
      <div className="body">
        <Translate stringId="salesText" data-testid="salesTextLabel" /> : <span data-testid="salesText"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="strengthClass" data-testid="strengthClassLabel" /> :{' '}
        <span data-testid="strengthClass"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="environmentExposure" data-testid="environmentExposureLabel" /> :{' '}
        <span data-testid="environmentExposure"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="metExposureClasses" data-testid="metExposureClassesLabel" /> :{' '}
        <span data-testid="metExposureClasses">{unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="dmax" data-testid="dmaxLabel" /> : <span data-testid="dmax">{unsure} </span>
      </div>
      <div className="body">
        <Translate stringId="standardCert" data-testid="standardCertLabel" /> :{' '}
        <span data-testid="standardCert"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="workabilityTarget" data-testid="workabilityTargetLabel" /> :{' '}
        <span data-testid="workabilityTarget"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="stoneQuality" data-testid="stoneQualityLabel" /> :{' '}
        <span data-testid="stoneQuality"> {unsure}</span>
      </div>

      <div className="body">
        <Translate stringId="sandQuality" data-testid="sandQualityLabel" /> :{' '}
        <span data-testid="sandQuality"> {unsure}</span>
      </div>

      <div className="body">
        <Translate stringId="targetWC" data-testid="targetWCLabel" /> : <span data-testid="targetWC"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="controlClass" data-testid="controlClassLabel" /> :{' '}
        <span data-testid="controlClass"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="chlorideClass" data-testid="chlorideClassLabel" /> :{' '}
        <span data-testid="chlorideClass"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="typeAndStrength1" data-testid="typeAndStrength1Label" /> :{' '}
        <span data-testid="typeAndStrength1"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="typeAndStrength2" data-testid="typeAndStrength2Label" /> :{' '}
        <span data-testid="typeAndStrength2"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="typeOfAddition" data-testid="typeOfAdditionLabel" /> :{' '}
        <span data-testid="typeOfAddition"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="typeOfAdmixture" data-testid="typeOfAdmixtureLabel" /> :{' '}
        <span data-testid="typeOfAdmixture"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="orderedTemp" data-testid="orderedTempLabel" /> :{' '}
        <span data-testid="orderedTemp"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="fibers1" data-testid="fibers1Label" /> : <span data-testid="fibers1"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="fibers2" data-testid="fibers2Label" /> : <span data-testid="fibers2"> {unsure}</span>
      </div>
      <div className="body">
        <Translate stringId="calculatedMaturityTime" data-testid="calculatedMaturityTimeLabel" /> :{' '}
        <span data-testid="calculatedMaturityTime"> {unsure}</span>
      </div>
    </Styled>
  );
};

export default MaterialInfo;
